export default (date: string): boolean => {
  const expire = new Date(date).getTime()
  const now = new Date().getTime()
  return expire < now
}
